import { getEventLoader } from '../../common/utils';
import '../../../resources/static/scss/all.scss';

import RecoverPasswordPage from "./recover_password_page";

export const bootstrap = (windowObject: Window, documentObject: Document) => {

    const recoverPasswordPage = new RecoverPasswordPage(documentObject)
    recoverPasswordPage.registerSubmitButtonSpinner()
};

getEventLoader().onAllPreloadScriptsLoaded(10, () => bootstrap(window, document))

